import { ReviewCategory } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { CategoryReview } from '../../../ReviewCard/ReviewCard.types'

interface GetOverallRatingProps {
  categoryReviews: CategoryReview[]
}

export const getOverallRating = ({ categoryReviews }: GetOverallRatingProps) => {
  const overallRating = categoryReviews.find(review => {
    return review.category === ReviewCategory.nps || review.category === ReviewCategory.overall
  })

  return overallRating
}

export const hasTagsOrComments = (categoryReviews: CategoryReview[]) => {
  return categoryReviews.some(review => review.comment || review.tags)
}

export const labelByReviewCategory: Record<string, string> = {
  [ReviewCategory.onlineListing]: 'Accuracy',
  [ReviewCategory.checkIn]: 'Check-In',
  [ReviewCategory.roomCleanliness]: 'Cleanliness',
}
